import { Checkbox } from '@/components/common/Checkbox'
import { StepShell } from '../StepShell'

const DEFAULT = {
  written_consent_obtained: false,
  procedure_explained: false,
  risks_explained: false,
}

export function ConsentStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 13 — Phase 5"
      title="Consent"
      description="Documenting informed consent protects both the patient and the clinic."
    >
      <div className="space-y-2.5">
        <Checkbox
          label="Procedure explained to the patient"
          description="The patient understands what will be done."
          checked={v.procedure_explained}
          onChange={(b) => set({ procedure_explained: b })}
        />
        <Checkbox
          label="Risks & alternatives explained"
          description="Possible complications, success rate and alternative options."
          checked={v.risks_explained}
          onChange={(b) => set({ risks_explained: b })}
        />
        <Checkbox
          label="Written consent obtained"
          description="Signed consent form is on file."
          checked={v.written_consent_obtained}
          onChange={(b) => set({ written_consent_obtained: b })}
        />
      </div>
    </StepShell>
  )
}
